import { AfterViewInit, Directive, ElementRef, inject, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appNoInitialTransition]'
})
export class NoInitialTransitionDirective implements AfterViewInit {
    private readonly el = inject(ElementRef);
    private readonly renderer = inject(Renderer2);

    constructor() {
        this.renderer.addClass(this.el.nativeElement, 'no-transition');
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.renderer.removeClass(this.el.nativeElement, 'no-transition');
        });
    }
}
